export const headerList = [
    {
        prop: "id",
        label: "ID",
        width: 80,
    },
    {
        prop: "cover",
        label: "讲解卡",
    },
    {
        prop: "anchor_title",
        label: "锚点标题",
    },
    {
        prop: "title",
        label: "关联课程",
    },
    {
        prop: "dy_product_status",
        label: "状态",
        width: 240
    },
    {
        prop: "created_time",
        label: "添加时间",
        width: 170
    },
]